import React, { useState, useEffect, useCallback,useRef } from "react";
import DropDownButton from "devextreme-react/drop-down-button";
import data from "../../assets/apiRoutes.json";
import "devextreme/data/odata/store";
import { connect } from "react-redux";
import { GridLayout } from "../../common/GridLayout";
import { Localization } from "../../common/Localization";
import {
  Column,
  DataGrid,
  GroupPanel,
  SearchPanel,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnFixing,
  StateStoring,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import axios from "axios";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
const SerialNumberExpressTable = (props) => {
  const dataGrid = useRef(null);
  const [loading, setLoading] = useState("Data Loading");
  var accessToken = props.oidc.user.access_token;
  useEffect(() => {
    loadSerialdata();
  }, []);
  const [serialData, setSerialData] = useState([]);
  const loadSerialdata = () => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SerialNumber}?id=${props.id}&detailrowid=${props.detailrowid}&subdetailrowid=${props.subdetailrowid}&itemrowid=${props.itemrowid}&lotRowid=${props.lotRowid}&sublotrowid=${props.sublotrowid}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        setSerialData(res.data);
        if (serialData && serialData.length == 0) setLoading("No Data Found");
      })
      .catch((err) => {
        console.log(err, "err in load serial number");
        setLoading("No Data Found");
      });
  };

  const buttonDropDownOptions = { width: 140 };
  // tabs handling
  const [currentTab, setCurrentTab] = useState(2);
  const [currentLayout, setCurrentLayout] = useState("Default");

  const changeCurrentTab = (e) => {
    setCurrentTab(e.tab);
    var request = {
      value: e.itemData.tab,
      id: e.itemData.rowId,
    };
    props.changeTab(request);
  };
  const allowedPageSizes = [5, 10, 20, "all"];

  const gridKey = "8eb1fae8-0711-433a-8468-67a7c7b1b633";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  return (
    <div>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        ref={dataGrid}
        noDataText={loading}
        dataSource={serialData}
        showBorders={true}
        className={props?.SearchPanelAccordionStatus ? "GridHeightAccordianOpen-tabs" : "GridHeightAccordianClose-tabs"}
        hoverStateEnabled={true}
        allowColumnResizing={true}
        allowColumnReordering={true}
      >
        <Column dataField="rowid" caption="" cellRender={(rowid) => cellRender(rowid)} />
        <ColumnChooser enabled={true} />
        <ColumnFixing enabled={true} />
        <ColumnHeaderFilter />
        <Export enabled={true} allowExportSelectedData={true} text="Export" />
        <Sorting mvisible={true} mode="multiple" />
        {/* <Editing mode="cell" allowUpdating={true} /> */}
        <LoadPanel enabled={false} />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <HeaderFilter visible={true} />
        <GroupPanel visible={true} />
        <SearchPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Column dataField="serialnumber" caption={Localization.formatMessage('WMSERIALNUMBER.SERIALNUMBER', 'Serial Number')}></Column>
        <Column dataField="Netweight" caption={Localization.formatMessage('WMSERIALNUMBER.NETWEIGHT', 'Net Weight')}></Column>
        <Column dataField="Grossweight" caption={Localization.formatMessage('WMSERIALNUMBER.GROSSWEIGHT', 'Gross Weight')}></Column>
        <Column dataField="packageid" caption={Localization.formatMessage('WMSERIALNUMBER.PACKAGEID', 'Package Id')}></Column>
        <Column dataField="receiptverified" caption={Localization.formatMessage('WMSERIALNUMBER.RECEIPT_VERIFIED', 'Receipt Verified')}></Column>
        <Column dataField="shipmentverified" caption={Localization.formatMessage('WMSERIALNUMBER.SHIPMENT_VERIFIED', 'Shipment Verified')}></Column>
        <Column dataField="damageflag" caption={Localization.formatMessage('WMSERIALNUMBER.DAMAGEFLAG', 'Damage Flag')}></Column>
        <Column dataField="damagedescription" caption={Localization.formatMessage('WMSERIALNUMBER.DAMAGEDESCRIPTION', 'Damage Description')}></Column>
        <Toolbar>
          <Item location="after">
            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
  function cellRender(rowid) {
    return (
      <DropDownButton
        className="dropdownWithoutText"
        dropDownOptions={buttonDropDownOptions}
        items={[
          { name: "Lots", tab: 0, rowId: rowid.data.rowid },
        ]}
        displayExpr="name"
        onItemClick={(e) => changeCurrentTab(e)}
        keyExpr="rowId"
      />
    );
  }
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(SerialNumberExpressTable);
